import styled from 'styled-components'

import SectionWrapper from 'components/SectionWrapper'

export const SectionsWrapperStyled = styled(SectionWrapper)`
  background-color: ${p => p.theme.colors.purpleHeart};
`

export const Wrapper = styled.div`
  position: relative;
`

export const ForeverBox = styled.div`
  ${p => p.theme.mq.upLg} {
    position: relative;
    z-index: 2;
  }
`

export const CoveringBox = styled.div`
  ${p => p.theme.mq.upLg} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`
